
//mail contants
// export const MailUserName = 'MailUserName';
// export const MailPassword = 'MailPassword';
// export const MailFrom = 'MailFrom';
// export const MailBody = 'MailBody';
// export const Host = 'Host';
// export const Port = 'Port';


export const MailUserName = 'SMTPUserName';
export const MailPassword = 'SMTPPassword';
export const MailFrom = 'MailFrom';
export const MailBody = 'MailBody';
export const Host = 'host';
export const Port = 'port';
export const Mail_Template = 'mailTemplate';